import React from 'react';
import { ActionLink } from '../ui/ActionLink';
import type { Fact } from '../../types/content';
interface CourseGlanceProps {
  facts: Fact[];
  intensities?: {
    name: string;
    lessons: string;
    text: string;
  }[];
  primary: {
    label: string;
    to: string;
  };
}

// Sticky summary card: the key facts and the two study options, always one click from enquiring.
export function CourseGlance({
  facts,
  intensities,
  primary
}: CourseGlanceProps) {
  return <aside aria-label="Course at a glance" className="rounded-[28px] bg-mist p-6 md:p-8 lg:sticky lg:top-[156px]" data-id="element-273" data-mp="oxbr7canzefa">
      <h3 className="type-h4 text-ink" data-id="element-274" data-mp="tr6dmnhnm7i2">At a glance</h3>
      <dl className="mt-5 divide-y divide-line border-y border-line" data-id="element-275" data-mp="f1rzz371p3wv">
        {facts.map(fact => <div key={fact.label} className="flex items-baseline justify-between gap-4 py-3" data-id="element-276" data-mp="k0bpfdkukxtz">
            <dt className="type-small text-muted" data-id="element-277" data-mp="6127o9gztvnw">{fact.label}</dt>
            <dd className="text-right type-list text-ink" data-id="element-278" data-mp="a148yhitgn2n">{fact.value}</dd>
          </div>)}
      </dl>
      {intensities?.length ? <>
          <p className="mt-6 type-label text-muted" data-id="element-279" data-mp="2boch669qh376">Choose your pace</p>
          <ul className="mt-3 grid gap-3" data-id="element-280" data-mp="26q2mdwrx84m3">
            {intensities.map(option => <li key={option.name} className="rounded-[18px] bg-white p-4" data-id="element-281" data-mp="2lomqvgwk7shl">
                <div className="flex items-baseline justify-between gap-3" data-id="element-282" data-mp="2gpjq48nm48ff">
                  <span className="type-h5 text-ink" data-id="element-283" data-mp="2gnfnrv5d3hh9">{option.name}</span>
                  <span className="type-small font-semibold text-brand-press" data-id="element-284" data-mp="1szz2vdkfep0c">{option.lessons}</span>
                </div>
                <p className="mt-1 type-small text-body" data-id="element-285" data-mp="1nyrtja2mxhrk">{option.text}</p>
              </li>)}
          </ul>
        </> : null}
      <ActionLink to={primary.to} className="mt-6 w-full" data-id="element-286" data-mp="1xyithr9ysoz1">
        {primary.label}
      </ActionLink>
    </aside>;
}